import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import useHandleErrors from "../../utils/user.utils";
import { useUser } from "../../utils/userContext";
import Select from "react-select";
import useCountryCodes from "../../utils/useCountryCodes";
import useConfiguration from "../../utils/ConfigurationContext";

export default function Registerassest() {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choose file");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [supplierDetailsMap, setSupplierDetailsMap] = useState(new Map());
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const { user } = useUser();
  const config = useConfiguration();
  
  const initialState = {
    AssetId: "",
    SerialNumber: "",
    CategoryType: "",
    PurchaseDate: "",
    PurchaseOrder: "",
    PurchaseCost: "",
    Model: "",
    InvoiceDate: "",
    InvoiceNumber: "",
    SupplierDetails: "",
    SupplierContact: "",
    WarrantyStartDate: "",
    WarrantyEndDate: "",
    AssetCondition: "",
    ActiveFlag: "Y",
    CreatedBy: user?.FirstName,
    Status: "Active",
    Comments: "no",
    currencySymbol: "",
    countryCode: "",
    SupplierName: "",
    SupplierAddress: "",
    ProductType: "",
  };
  
  const [formData, setFormData] = useState(initialState);
  const handleErrors = useHandleErrors();
  const { currencySymbols, countryCodes } = useCountryCodes();
  
  const options = currencySymbols?.map((country) => ({
    value: country.value,
    label: `${country.value} (${country.label})`,
  })) || [];
  
  const countryCodeOptions = countryCodes?.map((country) => ({
    value: country.value,
    label: `${country.value} (${country.label})`,
  })) || [];
  
  const categoryconditionsOptions = config?.assetManagement?.assetCondition?.map(
    (category) => ({
      value: category,
      label: category,
    })
  ) || [];

    const categoryOptions = config?.assetManagement?. assetCategory?.map(
    (category) => ({
      value: category,
      label: category,
      
    })
  ) || [];
  
  const productTypeOptions = [
    { value: "Owned", label: "Owned" },
    { value: "Rented", label: "Rented" },
  ];
  
  const ClearIndicator = () => null;

  useEffect(() => {
    const preloading = document.getElementById("preloading");
    setTimeout(() => {
      if (preloading) preloading.style.display = "none";
    }, 400);
    fetchSupplierDetails();
  }, []);

  const fetchSupplierDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("No token found. Please login.", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }
      
      const path = `/getSupplierDetails?type=${'Supplier'}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      const suppliers = response?.data?.supplierDetails || [];
      console.log("Raw supplier data:", suppliers);
      
      // Log the structure of the first supplier to understand the data format
      if (suppliers.length > 0) {
        console.log("First supplier structure:", suppliers[0]);
        console.log("Available keys:", Object.keys(suppliers[0]));
      }
      
      const formattedOptions = suppliers.map((supplier, index) => {
        // Try different possible ID fields
        const supplierId = supplier.id || 
                          supplier._id || 
                          supplier.supplierId || 
                          supplier.SupplierId ||
                          supplier.supplierName || // Use name as fallback ID
                          `supplier_${index}`; // Generate ID as last resort
        
        const supplierName = supplier.supplierName || 
                           supplier.SupplierName || 
                           supplier.name ||
                           `Supplier ${index + 1}`;
        
        console.log(`Supplier ${index}:`, {
          originalData: supplier,
          extractedId: supplierId,
          extractedName: supplierName
        });
        
        return {
          value: String(supplierId), // Ensure it's a string
          label: supplierName,
        };
      });
      
      // Create a map for quick lookup of supplier details
      const detailsMap = new Map();
      suppliers.forEach((supplier, index) => {
        const supplierId = supplier.id || 
                          supplier._id || 
                          supplier.supplierId || 
                          supplier.SupplierId ||
                          supplier.supplierName ||
                          `supplier_${index}`;
        
        detailsMap.set(String(supplierId), {
          id: String(supplierId),
          supplierName: supplier.supplierName || supplier.SupplierName || supplier.name || `Supplier ${index + 1}`,
          supplierContact: supplier.supplierContact || supplier.SupplierContact || supplier.contact || "",
          supplierAddress: supplier.supplierAddress || supplier.SupplierAddress || supplier.address || "",
          typeofProduct: supplier.typeofProduct || supplier.TypeofProduct || supplier.productType || "",
        });
      });
      
      console.log("Formatted supplier options:", formattedOptions);
      console.log("Supplier details map:", detailsMap);
      
      setSupplierOptions(formattedOptions);
      setSupplierDetailsMap(detailsMap);
    } catch (error) {
      console.error("Error fetching supplier details:", error);
      if (error.response?.status === 404) {
        setSupplierOptions([]);
        setSupplierDetailsMap(new Map());
      } else {
        handleErrors(
          error.response || {
            data: { message: "Failed to fetch supplier details" },
          }
        );
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleKeyPress = (event) => {
    const charCode = event.charCode || event.keyCode;
    if (charCode < 48 || charCode > 57) event.preventDefault();
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setFormData(initialState);
    setSelectedSupplier(null);
    setFile(null);
    setFileName("Choose file");
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  // Fixed supplier selection handler
  const handleSupplierSelection = (selectedOption) => {
    console.log("Supplier selection changed:", selectedOption);
    
    setSelectedSupplier(selectedOption);
    
    const supplierId = selectedOption ? selectedOption.value : "";
    console.log("Selected Supplier ID:", supplierId);
    console.log("Selected Supplier Value type:", typeof supplierId);
    
    setFormData(prevFormData => ({
      ...prevFormData,
      SupplierDetails: supplierId,
    }));
    
    console.log("Updated formData.SupplierDetails:", supplierId);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    console.log("Form submission - Current formData:", formData);
    console.log("SupplierDetails value:", formData.SupplierDetails);
    console.log("SupplierDetails type:", typeof formData.SupplierDetails);
    console.log("Selected supplier:", selectedSupplier);
    console.log("Available supplier options:", supplierOptions);
    console.log("Supplier details map:", supplierDetailsMap);
    
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found. Please login.", {
        position: toast.POSITION.TOP_CENTER,
      });
      setLoading(false);
      return;
    }

    // Validation with detailed logging
    const requiredFields = [
      { field: 'AssetId', message: 'Asset Id is Required' },
      { field: 'SerialNumber', message: 'Serial Number is Required' },
      { field: 'CategoryType', message: 'Category Type is Required' },
      { field: 'PurchaseDate', message: 'Purchase Date is Required' },
      { field: 'InvoiceDate', message: 'Invoice Date is Required' },
      { field: 'InvoiceNumber', message: 'Invoice Number is Required' },
      { field: 'SupplierDetails', message: 'Supplier Details is Required' },
      { field: 'WarrantyStartDate', message: 'Warranty Start Date is Required' },
      { field: 'ProductType', message: 'Product Type is Required' },
      { field: 'AssetCondition', message: 'Asset Condition is Required' },
    ];

    for (const { field, message } of requiredFields) {
      const fieldValue = formData[field];
      console.log(`Checking field ${field}:`, fieldValue, `(type: ${typeof fieldValue})`);
      
      // Check for undefined, null, empty string, or "undefined" string
      if (!fieldValue || fieldValue === "undefined" || fieldValue === undefined || fieldValue === null) {
        console.log(`Validation failed for field: ${field}`);
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setLoading(false);
        return;
      }
    }

    if (
      formData.WarrantyEndDate &&
      formData.WarrantyStartDate >= formData.WarrantyEndDate
    ) {
      toast.error(
        "Warranty End Date must be greater than Warranty Start Date",
        { position: toast.POSITION.TOP_CENTER }
      );
      setLoading(false);
      return;
    }

    // Get supplier details from the map
    const selectedSupplierDetails = supplierDetailsMap.get(formData.SupplierDetails);
    console.log("Selected supplier details:", selectedSupplierDetails);
    console.log("Looking for supplier ID:", formData.SupplierDetails);
    console.log("Available IDs in map:", Array.from(supplierDetailsMap.keys()));
    
    if (!selectedSupplierDetails) {
      toast.error("Selected supplier details not found. Please select a valid supplier.", {
        position: toast.POSITION.TOP_CENTER,
      });
      setLoading(false);
      return;
    }

    // Prepare form data
    const fullClaimAmount = formData.currencySymbol && formData.PurchaseCost 
      ? `${formData.currencySymbol.split("-")[0]} ${formData.PurchaseCost}`
      : formData.PurchaseCost;

    const data = new FormData();
    
    // Add file if exists
    if (file) {
      data.append("InvoiceFile", file);
    }
    
    // Add basic form fields
    data.append("AssetId", formData.AssetId);
    data.append("SerialNumber", formData.SerialNumber);
    data.append("CategoryType", formData.CategoryType);
    data.append("PurchaseDate", formData.PurchaseDate);
    data.append("PurchaseOrder", formData.PurchaseOrder || "");
    data.append("PurchaseCost", fullClaimAmount || "");
    data.append("Model", formData.Model || "");
    data.append("InvoiceDate", formData.InvoiceDate);
    data.append("InvoiceNumber", formData.InvoiceNumber);
    data.append("WarrantyStartDate", formData.WarrantyStartDate);
    data.append("WarrantyEndDate", formData.WarrantyEndDate || "");
    data.append("AssetCondition", formData.AssetCondition);
    data.append("ProductType", formData.ProductType);
    
    // Add supplier details from the selected supplier
    data.append("SupplierDetails", formData.SupplierDetails);
    data.append("SupplierName", selectedSupplierDetails.supplierName);
    data.append("SupplierContact", selectedSupplierDetails.supplierContact);
    data.append("SupplierAddress", selectedSupplierDetails.supplierAddress);
    
    // Add static fields
    data.append("ActiveFlag", "Y");
    data.append("CreatedBy", user?.FirstName || "");
    data.append("Status", "Active");
    data.append("Comments", "NA");

    console.log("FormData contents:");
    for (let [key, value] of data.entries()) {
      console.log(`FormData: ${key} = ${value}`);
    }

    try {
      const path = "/registerAssests";
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      
      if (response.status === 200) {
        toast.success("Asset registered successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
        setShowModal(true);
        setFormData(initialState);
        setSelectedSupplier(null);
        setFile(null);
        setFileName("Choose file");
      } else {
        handleErrors(response);
      }
    } catch (error) {
      console.error("Submit error:", error);
      if (error.response) handleErrors(error.response);
      else
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSupplierDetailsClick = () => {
    setShowSupplierModal(true);
  };

  const handleCloseSupplierModal = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found. Please login.", {
        position: toast.POSITION.TOP_CENTER,
      });
      setLoading(false);
      return;
    }

    // Validation for supplier modal
    const supplierRequiredFields = [
      { field: 'SupplierName', message: 'Supplier Name is required' },
      { field: 'SupplierContact', message: 'Supplier Contact is required' },
      { field: 'SupplierAddress', message: 'Supplier Address is required' },
      { field: 'TypeofProduct', message: 'Type of Product is required' },
      { field: 'countryCode', message: 'Country Code is required' },
    ];

    for (const { field, message } of supplierRequiredFields) {
      if (!formData[field]) {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setLoading(false);
        return;
      }
    }

    try {
      const path = "/supplierDetails";
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(
        URL,
        {
          SupplierName: formData.SupplierName,
          SupplierContact: `${formData.countryCode.split("-")[0]} ${formData.SupplierContact}`,
          SupplierAddress: formData.SupplierAddress,
          TypeofProduct: formData.TypeofProduct,
          Type: "Supplier",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Supplier registered successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        setShowSupplierModal(false);
        
        // Clear supplier modal fields but keep main form data
        setFormData(prevFormData => ({
          ...prevFormData,
          SupplierName: "",
          SupplierContact: "",
          SupplierAddress: "",
          TypeofProduct: "",
          countryCode: "",
        }));
        
        // Refresh supplier options
        await fetchSupplierDetails();
      }
    } catch (error) {
      console.error("Supplier registration error:", error);
      if (error.response) {
        handleErrors(error.response);
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <div id="preloading">
          <span className="loader"></span>
        </div>
      )}
      <ToastContainer />
      <div className="content-page">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col">
              <h3 className="title mb-2">Register Asset</h3>
            </div>
            <div className="col-auto">
              <Button variant="primary" onClick={handleSupplierDetailsClick}>
                <i className="ri-list-indefinite"></i> Add Supplier
              </Button>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-12">
                <div className="card mb-4">
                  <div className="card-body">
                    <h5
                      className="title accordion-title"
                      data-toggle="collapse"
                      data-target="#assetDetails"
                    >
                      Asset Information
                    </h5>
                    <div id="registerAssetDetails">
                      <div
                        className="row collapse show"
                        id="assetDetails"
                        data-parent="#registerAssetDetails"
                      >
                        {/* Basic Asset Information */}
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="assetID" className="required">
                            Asset ID
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="AssetId"
                            value={formData.AssetId}
                            onChange={handleChange}
                            placeholder="Enter Asset ID"
                          />
                        </div>

                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="serialNumber" className="required">
                            Serial Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="SerialNumber"
                            value={formData.SerialNumber}
                            onChange={handleChange}
                            placeholder="Enter Serial Number"
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="CategoryType" className="required">
                            Category Type
                          </label>
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="CategoryType"
                            value={
                              categoryOptions.find(
                                (option) =>
                                  option.value === formData.CategoryType
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFormData({
                                ...formData,
                                CategoryType: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            options={categoryOptions}
                            components={{ ClearIndicator }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, zIndex: 1 }),
                            }}
                            placeholder="Select Category Type"
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="assetModel">Model</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Model"
                            value={formData.Model}
                            onChange={handleChange}
                            placeholder="Enter Model"
                          />
                        </div>

                        {/* Purchase Details */}
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="purchaseDate" className="required">
                            Purchase Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="PurchaseDate"
                            value={formData.PurchaseDate}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="purchaseOrder">Purchase Order</label>
                          <input
                            type="text"
                            className="form-control"
                            name="PurchaseOrder"
                            value={formData.PurchaseOrder}
                            onChange={handleChange}
                            placeholder="Enter Purchase Order"
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="purchaseCost">Purchase Cost</label>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                name="currencySymbol"
                                value={
                                  options.find(
                                    (option) =>
                                      option.value === formData.currencySymbol?.split("-")[0]
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  setFormData({
                                    ...formData,
                                    currencySymbol: selectedOption
                                      ? `${selectedOption.value}-${options.indexOf(selectedOption)}`
                                      : "",
                                  });
                                }}
                                options={options}
                                components={{ ClearIndicator }}
                                isClearable
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  control: (base) => ({ ...base, zIndex: 1 }),
                                }}
                                placeholder="Currency"
                              />
                            </div>
                            <input
                              type="number"
                              className="form-control"
                              name="PurchaseCost"
                              value={formData.PurchaseCost}
                              onChange={handleChange}
                              placeholder="Enter Amount"
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="ProductType" className="required">
                            Product Type
                          </label>
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="ProductType"
                            value={
                              productTypeOptions.find(
                                (option) => option.value === formData.ProductType
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFormData({
                                ...formData,
                                 ProductType: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            options={productTypeOptions}
                            components={{ ClearIndicator }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, zIndex: 1 }),
                            }}
                            placeholder="Select Product Type"
                          />
                        </div>

                        {/* Invoice Details */}
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="invoiceDate" className="required">
                            Invoice Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="InvoiceDate"
                            value={formData.InvoiceDate}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="invoiceNumber" className="required">
                            Invoice Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="InvoiceNumber"
                            value={formData.InvoiceNumber}
                            onChange={handleChange}
                            placeholder="Enter Invoice Number"
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="uploadInvoice">Upload Invoice</label>
                          <div className="input-group">
                            <div className="custom-file">
                              <input
                                className="custom-file-input"
                                onChange={handleFileChange}
                                type="file"
                                id="file"
                                name="uploadInvoice"
                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="uploadInvoice"
                              >
                                {fileName}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="supplierDetails" className="required">
                            Supplier Details
                          </label>
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="SupplierDetails"
                            value={selectedSupplier}
                            onChange={handleSupplierSelection}
                            options={supplierOptions}
                            components={{ ClearIndicator }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, zIndex: 1 }),
                            }}
                            placeholder="Select a supplier"
                            noOptionsMessage={() => "No suppliers found. Please add a supplier first."}
                            isLoading={loading}
                          />
                        </div>

                        {/* Warranty Details */}
                        <div className="form-group col-md-6 col-lg-3">
                          <label
                            htmlFor="warrantyStartDate"
                            className="required"
                          >
                            Warranty Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="WarrantyStartDate"
                            value={formData.WarrantyStartDate}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="warrantyEndDate">
                            Warranty End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="WarrantyEndDate"
                            value={formData.WarrantyEndDate}
                            onChange={handleChange}
                            min={formData.WarrantyStartDate}
                          />
                        </div>
                        <div className="form-group col-md-6 col-lg-3">
                          <label htmlFor="assetCondition" className="required">
                            Asset Condition
                          </label>
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="AssetCondition"
                            value={
                              categoryconditionsOptions.find(
                                (option) =>
                                  option.value === formData.AssetCondition
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFormData({
                                ...formData,
                                AssetCondition: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            options={categoryconditionsOptions}
                            components={{ ClearIndicator }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, zIndex: 1 }),
                            }}
                            placeholder="Select Asset Condition"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row fixed-footer">
              <div className="col-lg-12 text-center">
                <button
                  className="btn btn-light mr-2"
                  type="button"
                  onClick={handleCancel}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"} <i className="ri-checkbox-circle-line"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Success Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="successModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div className="modal-content shadow success-modal">
              <div className="modal-header py-2">
                <h6 className="modal-title" id="successModalLabel">
                  Success!
                </h6>
                <button
                  className="close"
                  type="button"
                  aria-label="Close"
                  onClick={handleCloseModal}
                >
                  <span aria-hidden="true">
                    <i className="ri-close-circle-fill font-size-20"></i>
                  </span>
                </button>
              </div>
              <div className="modal-body pb-5">
                <div className="row">
                  <div className="col-12 text-success text-center">
                    <i className="ri-checkbox-circle-fill"></i>
                  </div>
                  <div className="col-12 text-center">
                    Asset Registered successfully.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Supplier Details Modal */}
      <Modal
        show={showSupplierModal}
        onHide={() => setShowSupplierModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Supplier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card">
            <div className="card-body">
              <h5 className="title accordion-title">Supplier Information</h5>
              <div className="row">
                <div className="form-group col-md-6 col-lg-6">
                  <label htmlFor="SupplierName" className="required">
                    Supplier Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="SupplierName"
                    value={formData.SupplierName}
                    onChange={handleChange}
                    placeholder="Enter supplier name"
                  />
                </div>
                <div className="form-group col-md-6 col-lg-6">
                  <label htmlFor="TypeofProduct" className="required">
                    Type of Product
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="TypeofProduct"
                    value={formData.TypeofProduct}
                    onChange={handleChange}
                    placeholder="Enter product type"
                  />
                </div>
                <div className="form-group col-md-6 col-lg-6">
                  <label htmlFor="SupplierContact" className="required">
                    Supplier Contact
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="countryCode"
                        value={
                          countryCodeOptions.find(
                            (option) =>
                              option.value === formData.countryCode?.split("-")[0]
                          ) || null
                        }
                        onChange={(selectedOption) => {
                          setFormData({
                            ...formData,
                            countryCode: selectedOption
                              ? `${selectedOption.value}-${countryCodeOptions.indexOf(selectedOption)}`
                              : "",
                          });
                        }}
                        options={countryCodeOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                        placeholder="Select country code"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="SupplierContact"
                      value={formData.SupplierContact}
                      onChange={handleChange}
                      onKeyPress={handleKeyPress}
                      placeholder="Enter contact number"
                    />
                  </div>
                </div>
                <div className="form-group col-md-6 col-lg-6">
                  <label htmlFor="SupplierAddress" className="required">
                    Supplier Address
                  </label>
                  <textarea
                    className="form-control"
                    rows={3}
                    name="SupplierAddress"
                    value={formData.SupplierAddress}
                    onChange={handleChange}
                    placeholder="Enter supplier address"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            onClick={() => {
              setFormData({
                SupplierName: '',
                SupplierContact: '',
                SupplierAddress: '',
                TypeofProduct: '',
                countryCode: '',
              });
              setShowSupplierModal(false);
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleCloseSupplierModal}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"} <i className="ri-checkbox-circle-line"></i>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
